


























































import { Component, Vue, Watch, Prop } from 'vue-property-decorator';
import { filterEmpty } from '@acgn/herm/src/util/business';
import { statisticDetailTimes } from '@/constants/type-helper';
import { namespace } from 'vuex-class';
import { AcgnFormTitle } from '@/components';
import { AcgnTable, AcgnPermission } from '@acgn/herm/src/ui';
import { openUrl } from '@/util';
import { displayFormValidationError } from '@acgn/herm/src/util/form';
import AcgnPopFiledModify from '../pop-field-modify.vue';
import AcgnPopFiledHistory from '../pop-field-history.vue';

const StatisticAction = namespace('desk/statistic').Action;
const StatisticGetter = namespace('desk/statistic').Getter;
import { DataTypesMixin } from '@/mixins';

@Component({
  components: {
    AcgnTable,
    AcgnFormTitle,
    AcgnPermission,
    AcgnPopFiledModify,
    AcgnPopFiledHistory
  },
  mixins: [ DataTypesMixin ]
})

/**
 * 逾期情况-管理方
 */
export default class AcgnOverdueDetail extends Vue {

  @Prop({ default: null }) public comicId: number | null; // 项目id
  @Prop({ default: null }) public userId: number | null; // 员工id
  @Prop({ default: false }) public isShowModify: boolean; // 显示修改按钮
  @Prop({ default: '' }) public exportCode: string; // 导出权限码

  @StatisticAction private getOverdueCycleAdminDetail: any;
  @StatisticGetter private loadings: any; // loading
  @StatisticAction private reviseOverdue: any;

  private selectOpts: any = statisticDetailTimes;
  private selectType: number = 2;
  private popData: any = {};
  private visible: boolean = false;

  private tableConfig: any = {
    columns: [
      {
        label: '项目',
        prop: 'time_slot',
        width: 200
      },
      {
        label: '逾期提交',
        prop: 'over_submit',
        render: (h: any, { row }: any) => (this as any).renderLink(row, 'over_submit')
      },
      {
        label: '逾期审批',
        prop: 'over_approve',
        render: (h: any, { row }: any) => (this as any).renderLink(row, 'over_approve')
      },
      {
        label: '逾期提交率',
        prop: 'over_submit_rate'
      },
      {
        label: '逾期审批率',
        prop: 'over_approve_rate'
      }
    ],
    data: []
  };

  private pageConfig: any = {}; // 分页数据
  private dataType: number = (this as any).comicId ? 2 : 1;
  private options: any = {
    apiType: 2,
    userId: (this as any).userId,
    cycle_type: this.dataType > 0 ? 3 : this.selectType,
    project_id: (this as any).comicId
  };

  private renderLink(row: any, key: string) {
    const values = row[key];
    const type = key === 'over_submit' ? 1 : 2;
    const subType = key === 'over_submit' ? 2 : 1;

    const numValue = values[0];
    const numDiff = values[1];
    const data = {
      type: subType,
      title: row.time_slot,
      field: type ? '逾期提交' : '逾期审批',
      value: numDiff,
      originValue: numValue
    };
    const classStyle = numDiff ? 'color--danger' : '';
    const numShow = numDiff ? numValue + numDiff : numValue;
    const params: any = { type };
    if (this.userId) {
      params.userid = this.userId;
    }
    if (this.comicId) {
      return (
        <div>
          <acgn-permission class={classStyle} to={{ name: 'desk-statisticOverdueComicDetail', params }}>
            {numShow}
          </acgn-permission>
          {this.isShowModify ? <span
            class="el-icon-edit color--primary"
            style="margin-left:4px;vertical-align: middle;cursor: pointer;"
            onClick={() => this.doCli(data)}
          >
          </span> : ''}
        </div>
      );
    }
    return (
      <span class={classStyle}>{numShow}</span>
    );
  }

  private doCli(data: any) {
    this.visible = true;
    this.popData = data;
  }

  private async sumbit(data: any) {
    const dataClone: any = {};
    dataClone.time_slot = data.title;
    dataClone.described = data.field;
    dataClone.revised_num = data.value;
    dataClone.described = data.remark;
    dataClone.revised_extra = data.revised_extra;
    dataClone.type = data.type;
    dataClone.user_id = this.userId;
    dataClone.cycle_type = this.selectType;
    dataClone.project_id = this.comicId;
    try {
      await this.reviseOverdue(dataClone);
    } catch (ex) {
      this.$message.error(this.$language.error);
      return true;
    }
    this.$message.success('修改成功');
    this.initSearh();
    return false;
  }

  // table组件获取数据更新数据接口
  private async initSearh() {
    const { tableConfig, pageConfig } = this;
    const options = this.getSearchOptions();
    const { result } = await this.getOverdueCycleAdminDetail(options);
    this.tableConfig.columns[0].prop = this.dataType === 0 ? 'time_slot' : 'data_name';
    tableConfig.data = result;
  }

  private getSearchOptions() {
    return {
      type: this.selectType,
      project_id: this.comicId,
      user_id: this.userId,
      order: this.dataType > 0 ? 1 : 2,
      data_type: this.dataType
    };
  }

  private selectChange() {
    this.options.cycle_type = this.dataType > 0 ? 3 : this.selectType;
    this.initSearh();
  }

  private exportExcel() {
    openUrl('/api/v1/workbench/getoverduecycleofadmin?export=1', this.getSearchOptions());
  }
}
